import React, { useRef } from 'react';
import { motion } from 'framer-motion';
import { ExternalLink, Quote, ChevronLeft, ChevronRight, Play } from 'lucide-react';
const newsItems = [{
  source: 'Forbes',
  date: 'Oct 12, 2024',
  quote: 'MrBeast is redefining entertainment with a production scale that rivals major Hollywood studios.',
  link: '#'
}, {
  source: 'Variety',
  date: 'Oct 10, 2024',
  quote: "Beast Games isn't just a show; it's a cultural phenomenon that bridges YouTube and traditional TV.",
  link: '#'
}, {
  source: 'Entertainment Weekly',
  date: 'Sep 28, 2024',
  quote: 'The most ambitious reality competition ever conceived. The stakes are real and the drama is intense.',
  link: '#'
}, {
  source: 'The Verge',
  date: 'Sep 15, 2024',
  quote: 'A masterclass in viral content creation adapted for the biggest streaming stage.',
  link: '#'
}];
// YouTube videos from MrBeast channel related to Beast Games
const youtubeVideos = [{
  id: 'SI3CrHUAGqM',
  title: 'Beast Games Official Trailer',
  channel: 'MrBeast',
  views: '45M views'
}, {
  id: '2isYuQZMbdU',
  title: '$1 vs $100,000,000 House!',
  channel: 'MrBeast',
  views: '280M views'
}, {
  id: 'r7zJ8srwwjk',
  title: 'I Survived 7 Days In An Abandoned City',
  channel: 'MrBeast',
  views: '195M views'
}, {
  id: 'erLbbextvlY',
  title: '$1 vs $1,000,000 Hotel Room!',
  channel: 'MrBeast',
  views: '220M views'
}, {
  id: 'WcwGleN38zE',
  title: 'Ages 1 - 100 Decide Who Wins $250,000',
  channel: 'MrBeast',
  views: '185M views'
}, {
  id: '9bqk6ZUsKyA',
  title: 'I Built 100 Homes And Gave Them Away',
  channel: 'Beast Philanthropy',
  views: '95M views'
}];
export function InTheNewsSection() {
  const scrollRef = useRef<HTMLDivElement>(null);
  const scroll = (direction: 'left' | 'right') => {
    if (scrollRef.current) {
      const scrollAmount = 400;
      scrollRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
      });
    }
  };
  return <section className="w-full py-24 bg-[#0f0f1a] relative" data-id="element-85">
      <div className="max-w-7xl mx-auto px-6" data-id="element-86">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-87">
          <h2 className="font-oswald text-4xl md:text-6xl font-bold text-white uppercase tracking-wider mb-4" data-id="element-88">
            In The <span className="text-[#ffd700]" data-id="element-89">News</span>
          </h2>
          <div className="w-24 h-1 bg-[#ffd700] mx-auto" data-id="element-90" />
        </motion.div>

        {/* Press Quotes Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-20" data-id="element-91">
          {newsItems.map((item, index) => <motion.a href={item.link} key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="group block bg-[#1a1a2e] p-8 rounded-xl border border-white/5 hover:border-[#ffd700]/50 transition-all duration-300 hover:-translate-y-2 relative overflow-hidden" data-id="element-92">
              <div className="absolute top-0 right-0 p-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-93">
                <ExternalLink className="w-5 h-5 text-[#ffd700]" data-id="element-94" />
              </div>

              <Quote className="w-8 h-8 text-[#ffd700]/20 mb-6 group-hover:text-[#ffd700] transition-colors" data-id="element-95" />

              <p className="text-gray-300 mb-6 font-light italic leading-relaxed min-h-[100px]" data-id="element-96">
                "{item.quote}"
              </p>

              <div className="border-t border-white/10 pt-4 flex justify-between items-end" data-id="element-97">
                <span className="font-oswald text-xl text-white uppercase tracking-wide group-hover:text-[#ffd700] transition-colors" data-id="element-98">
                  {item.source}
                </span>
                <span className="text-xs text-gray-500 font-mono" data-id="element-99">
                  {item.date}
                </span>
              </div>
            </motion.a>)}
        </div>

        {/* YouTube Channel Section */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="relative" data-id="element-100">
          <div className="flex items-center justify-between mb-8" data-id="element-101">
            <div className="flex items-center gap-4" data-id="element-102">
              <div className="w-12 h-12 bg-red-600 rounded-full flex items-center justify-center" data-id="element-103">
                <Play className="w-6 h-6 text-white fill-white" data-id="element-104" />
              </div>
              <div data-id="element-105">
                <h3 className="font-oswald text-2xl md:text-3xl font-bold text-white uppercase tracking-wide" data-id="element-106">
                  YouTube Channel
                </h3>
                <p className="text-gray-400 text-sm" data-id="element-107">Watch more from MrBeast</p>
              </div>
            </div>

            {/* Scroll Buttons */}
            <div className="hidden md:flex gap-2" data-id="element-108">
              <button onClick={() => scroll('left')} className="p-3 rounded-full bg-white/10 hover:bg-[#ffd700] hover:text-black transition-all text-white" data-id="element-109">
                <ChevronLeft className="w-6 h-6" data-id="element-110" />
              </button>
              <button onClick={() => scroll('right')} className="p-3 rounded-full bg-white/10 hover:bg-[#ffd700] hover:text-black transition-all text-white" data-id="element-111">
                <ChevronRight className="w-6 h-6" data-id="element-112" />
              </button>
            </div>
          </div>

          {/* Scrollable Video Container */}
          <div ref={scrollRef} className="flex gap-6 overflow-x-auto pb-4 scrollbar-hide snap-x snap-mandatory" style={{
          scrollbarWidth: 'none',
          msOverflowStyle: 'none'
        }} data-id="element-113">
            {youtubeVideos.map((video, index) => <motion.a key={video.id} href={`https://www.youtube.com/watch?v=${video.id}`} target="_blank" rel="noopener noreferrer" initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} whileHover={{
            scale: 1.02
          }} className="flex-shrink-0 w-[300px] md:w-[350px] snap-start group" data-id="element-114">
                {/* Video Thumbnail */}
                <div className="relative aspect-video rounded-xl overflow-hidden mb-3 border border-white/10 group-hover:border-[#ffd700]/50 transition-all" data-id="element-115">
                  <img src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`} alt={video.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-116" />
                  <div className="absolute inset-0 bg-black/30 group-hover:bg-black/10 transition-all flex items-center justify-center" data-id="element-117">
                    <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center opacity-90 group-hover:opacity-100 group-hover:scale-110 transition-all" data-id="element-118">
                      <Play className="w-8 h-8 text-white fill-white ml-1" data-id="element-119" />
                    </div>
                  </div>
                </div>

                {/* Video Info */}
                <h4 className="font-bold text-white text-sm md:text-base line-clamp-2 group-hover:text-[#ffd700] transition-colors mb-1" data-id="element-120">
                  {video.title}
                </h4>
                <div className="flex items-center gap-2 text-gray-400 text-xs" data-id="element-121">
                  <span data-id="element-122">{video.channel}</span>
                  <span data-id="element-123">•</span>
                  <span data-id="element-124">{video.views}</span>
                </div>
              </motion.a>)}
          </div>
        </motion.div>
      </div>
    </section>;
}